import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import './i18n/config'

// Debug: Log API configuration in production
if (import.meta.env.PROD) {
  console.log('[Kirstunvartija] Production build loaded')
  console.log('[Kirstunvartija] API_BASE:', import.meta.env.VITE_API_URL || 'https://kirstunvartija-backend.tuomas-508.workers.dev')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
